export default __webpack_public_path__ + "media/images/tablogin-b4065eaa77788f9a2241147aec818092.png";